import {
    ChangePhrasesSelectorWizardState,
    PhrasesSelectorColumnsVisibilityData,
    PhrasesSelectorInputColumns,
    PhrasesSelectorListItem,
    PhrasesSelectorWizardGroupInfo,
    PhrasesSelectorWizardId
} from '../typings/phrases';

import { PhrasesSelectorAction } from './phrases-selector';

export const UPDATE_PHRASES_SELECTOR_WIZARD_STATE = 'UPDATE_PHRASES_SELECTOR_WIZARD_STATE';
export type UPDATE_PHRASES_SELECTOR_WIZARD_STATE = typeof UPDATE_PHRASES_SELECTOR_WIZARD_STATE;
export interface UpdatePhrasesSelectorWizard {
    type: UPDATE_PHRASES_SELECTOR_WIZARD_STATE;
    wizardId: PhrasesSelectorWizardId;
    state: ChangePhrasesSelectorWizardState;
}
export function updatePhrasesSelectorWizardState(
    wizardId: PhrasesSelectorWizardId,
    state: ChangePhrasesSelectorWizardState
): UpdatePhrasesSelectorWizard {
    return {
        type: UPDATE_PHRASES_SELECTOR_WIZARD_STATE,
        wizardId,
        state
    };
}

export const ADD_PHRASES_START_INPUT_ITEMS = 'ADD_PHRASES_START_INPUT_ITEMS';
export type ADD_PHRASES_START_INPUT_ITEMS = typeof ADD_PHRASES_START_INPUT_ITEMS;
export interface AddPhrasesStartInputItems {
    type: ADD_PHRASES_START_INPUT_ITEMS;
    wizardId: PhrasesSelectorWizardId;
    value: string[];
}
export function addPhrasesStartInputItems(
    wizardId: PhrasesSelectorWizardId,
    value: string[]
): AddPhrasesStartInputItems {
    return {
        type: ADD_PHRASES_START_INPUT_ITEMS,
        wizardId,
        value
    };
}

export const FETCH_PHRASES_FOR_PHRASES_SELECTOR_WIZARD = 'FETCH_PHRASES_FOR_PHRASES_SELECTOR_WIZARD';
export type FETCH_PHRASES_FOR_PHRASES_SELECTOR_WIZARD = typeof FETCH_PHRASES_FOR_PHRASES_SELECTOR_WIZARD;

export interface FetchPhrasesForPhrasesSelectorWizardAction {
    type: FETCH_PHRASES_FOR_PHRASES_SELECTOR_WIZARD;
    wizardId: PhrasesSelectorWizardId;
    groupInfo: PhrasesSelectorWizardGroupInfo;
}

export function fetchPhrasesForPhrasesSelectorWizard(
    wizardId: PhrasesSelectorWizardId,
    groupInfo: PhrasesSelectorWizardGroupInfo
): FetchPhrasesForPhrasesSelectorWizardAction {
    return {
        type: FETCH_PHRASES_FOR_PHRASES_SELECTOR_WIZARD,
        wizardId,
        groupInfo
    };
}

export enum SelectionWizardListName {
    startPhrases = 'startPhrases',
    similarPhrases = 'similarPhrases',
    chosenPhrases = 'chosenPhrases',
    minusWords = 'minusWords',
    searchedAlso = 'searchedAlso'
}

export const PHRASES_SELECTOR_SELECTION_CHANGE = 'PHRASES_SELECTOR_SELECTION_CHANGE';
export type PHRASES_SELECTOR_SELECTION_CHANGE = typeof PHRASES_SELECTOR_SELECTION_CHANGE;
export interface SelectionChange {
    type: PHRASES_SELECTOR_SELECTION_CHANGE;
    wizardId: PhrasesSelectorWizardId;
    selection: boolean[];
    listName: SelectionWizardListName;
}
export function selectionChange(
    wizardId: PhrasesSelectorWizardId,
    selection: boolean[],
    listName: SelectionWizardListName
): SelectionChange {
    return {
        type: PHRASES_SELECTOR_SELECTION_CHANGE,
        wizardId,
        selection,
        listName
    };
}

export const PHRASES_SELECTOR_SUBMIT_SELECTION_WIZARD = 'PHRASES_SELECTOR_SUBMIT_SELECTION_WIZARD';
export type PHRASES_SELECTOR_SUBMIT_SELECTION_WIZARD = typeof PHRASES_SELECTOR_SUBMIT_SELECTION_WIZARD;

export interface SubmitSelectionWizard {
    type: PHRASES_SELECTOR_SUBMIT_SELECTION_WIZARD;
    wizardId: PhrasesSelectorWizardId;
}

export function submitSelectionWizard(wizardId: PhrasesSelectorWizardId): SubmitSelectionWizard {
    return {
        type: PHRASES_SELECTOR_SUBMIT_SELECTION_WIZARD,
        wizardId
    };
}

export const PHRASES_SELECTOR_DELETE_START_PHRASES = 'PHRASES_SELECTOR_DELETE_START_PHRASES';
export type PHRASES_SELECTOR_DELETE_START_PHRASES = typeof PHRASES_SELECTOR_DELETE_START_PHRASES;
export interface DeleteStartPhrases {
    type: PHRASES_SELECTOR_DELETE_START_PHRASES;
    wizardId: PhrasesSelectorWizardId;
    items: PhrasesSelectorListItem[];
}
export function deleteStartPhrases(
    wizardId: PhrasesSelectorWizardId,
    items: PhrasesSelectorListItem[]
): DeleteStartPhrases {
    return {
        type: PHRASES_SELECTOR_DELETE_START_PHRASES,
        wizardId,
        items
    };
}

export const PHRASES_SELECTOR_ADD_PHRASES_TO_CHOOSEN_LIST = 'PHRASES_SELECTOR_ADD_PHRASES_TO_CHOOSEN_LIST';
export type PHRASES_SELECTOR_ADD_PHRASES_TO_CHOOSEN_LIST = typeof PHRASES_SELECTOR_ADD_PHRASES_TO_CHOOSEN_LIST;
export interface AddPhrasesToChosenList {
    type: PHRASES_SELECTOR_ADD_PHRASES_TO_CHOOSEN_LIST;
    wizardId: PhrasesSelectorWizardId;
    items: PhrasesSelectorListItem[];
}
export function addPhrasesToChosenList(
    wizardId: PhrasesSelectorWizardId,
    items: PhrasesSelectorListItem[]
): AddPhrasesToChosenList {
    return {
        type: PHRASES_SELECTOR_ADD_PHRASES_TO_CHOOSEN_LIST,
        wizardId,
        items
    };
}

export const PHRASES_SELECTOR_REMOVE_PHRASES_FROM_CHOOSEN_LIST = 'PHRASES_SELECTOR_REMOVE_PHRASES_FROM_CHOOSEN_LIST';
export type PHRASES_SELECTOR_REMOVE_PHRASES_FROM_CHOOSEN_LIST = typeof PHRASES_SELECTOR_REMOVE_PHRASES_FROM_CHOOSEN_LIST;
export interface RemovePhrasesFromChosenList {
    type: PHRASES_SELECTOR_REMOVE_PHRASES_FROM_CHOOSEN_LIST;
    wizardId: PhrasesSelectorWizardId;
    items: PhrasesSelectorListItem[];
}
export function removePhrasesFromChosenList(
    wizardId: PhrasesSelectorWizardId,
    items: PhrasesSelectorListItem[]
): RemovePhrasesFromChosenList {
    return {
        type: PHRASES_SELECTOR_REMOVE_PHRASES_FROM_CHOOSEN_LIST,
        wizardId,
        items
    };
}

export const PHRASES_SELECTOR_ADD_PHRASES_TO_START_LIST = 'PHRASES_SELECTOR_ADD_PHRASES_TO_START_LIST';
export type PHRASES_SELECTOR_ADD_PHRASES_TO_START_LIST = typeof PHRASES_SELECTOR_ADD_PHRASES_TO_START_LIST;
export interface AddSearchedAlsoPhrasesToStartPhrases {
    type: PHRASES_SELECTOR_ADD_PHRASES_TO_START_LIST;
    wizardId: PhrasesSelectorWizardId;
    items: PhrasesSelectorListItem[];
}
export function addPhrasesToStartPhrases(
    wizardId: PhrasesSelectorWizardId,
    items: PhrasesSelectorListItem[]
): AddSearchedAlsoPhrasesToStartPhrases {
    return {
        type: PHRASES_SELECTOR_ADD_PHRASES_TO_START_LIST,
        wizardId,
        items
    };
}

export const PHRASES_SELECTOR_ADD_PHRASES_TO_MINUS_WORDS_LIST = 'PHRASES_SELECTOR_ADD_PHRASES_TO_MINUS_WORDS_LIST';
export type PHRASES_SELECTOR_ADD_PHRASES_TO_MINUS_WORDS_LIST = typeof PHRASES_SELECTOR_ADD_PHRASES_TO_MINUS_WORDS_LIST;
export interface AddPhrasesToMinusWordsList {
    type: PHRASES_SELECTOR_ADD_PHRASES_TO_MINUS_WORDS_LIST;
    wizardId: PhrasesSelectorWizardId;
    items: PhrasesSelectorListItem[];
}
export function addPhrasesToMinusWordsList(
    wizardId: PhrasesSelectorWizardId,
    items: PhrasesSelectorListItem[]
): AddPhrasesToMinusWordsList {
    return {
        type: PHRASES_SELECTOR_ADD_PHRASES_TO_MINUS_WORDS_LIST,
        wizardId,
        items
    };
}

export const PHRASES_SELECTOR_REMOVE_PHRASES_FROM_MINUS_WORDS_LIST =
    'PHRASES_SELECTOR_REMOVE_PHRASES_FROM_MINUS_WORDS_LIST';
export type PHRASES_SELECTOR_REMOVE_PHRASES_FROM_MINUS_WORDS_LIST = typeof PHRASES_SELECTOR_REMOVE_PHRASES_FROM_MINUS_WORDS_LIST;
export interface RemovePhrasesToMinusWordsList {
    type: PHRASES_SELECTOR_REMOVE_PHRASES_FROM_MINUS_WORDS_LIST;
    wizardId: PhrasesSelectorWizardId;
    items: PhrasesSelectorListItem[];
}
export function removePhrasesFromMinusWordsList(
    wizardId: PhrasesSelectorWizardId,
    items: PhrasesSelectorListItem[]
): RemovePhrasesToMinusWordsList {
    return {
        type: PHRASES_SELECTOR_REMOVE_PHRASES_FROM_MINUS_WORDS_LIST,
        wizardId,
        items
    };
}

export const OPEN_PHRASES_SELECTOR_WIZARD = 'OPEN_PHRASES_SELECTOR_WIZARD';
export type OPEN_PHRASES_SELECTOR_WIZARD = typeof OPEN_PHRASES_SELECTOR_WIZARD;
export interface OpenPhrasesSelectorWizard {
    type: OPEN_PHRASES_SELECTOR_WIZARD;
    wizardId: PhrasesSelectorWizardId;
    groupInfo: PhrasesSelectorWizardGroupInfo;
    keywords?: string[];
}
export function openPhrasesSelectorWizard(
    wizardId: PhrasesSelectorWizardId,
    groupInfo: PhrasesSelectorWizardGroupInfo
): OpenPhrasesSelectorWizard {
    return {
        type: OPEN_PHRASES_SELECTOR_WIZARD,
        wizardId,
        groupInfo
    };
}

export const SHOW_PHRASES_SELECTOR_WIZARD = 'SHOW_PHRASES_SELECTOR_WIZARD';
export type SHOW_PHRASES_SELECTOR_WIZARD = typeof SHOW_PHRASES_SELECTOR_WIZARD;

export interface ShowPhrasesSelectorWizard {
    type: SHOW_PHRASES_SELECTOR_WIZARD;
    wizardId: PhrasesSelectorWizardId;
}
export function showPhrasesSelectorWizard(wizardId: PhrasesSelectorWizardId): ShowPhrasesSelectorWizard {
    return {
        type: SHOW_PHRASES_SELECTOR_WIZARD,
        wizardId
    };
}

export const CLOSE_PHRASES_SELECTOR_WIZARD = 'CLOSE_PHRASES_SELECTOR_WIZARD';
export type CLOSE_PHRASES_SELECTOR_WIZARD = typeof CLOSE_PHRASES_SELECTOR_WIZARD;
export interface ClosePhrasesSelectorWizard {
    type: CLOSE_PHRASES_SELECTOR_WIZARD;
    wizardId: PhrasesSelectorWizardId;
}
export function closePhrasesSelectorWizard(wizardId: PhrasesSelectorWizardId): ClosePhrasesSelectorWizard {
    return {
        type: CLOSE_PHRASES_SELECTOR_WIZARD,
        wizardId
    };
}

export const PHRASES_SELECTOR_CHANGE_COLUMNS_VISIBILITY = 'PHRASES_SELECTOR_CHANGE_COLUMNS_VISIBILITY';
export type PHRASES_SELECTOR_CHANGE_COLUMNS_VISIBILITY = typeof PHRASES_SELECTOR_CHANGE_COLUMNS_VISIBILITY;
export interface ChangePhrasesWizardColumnsVisibility {
    type: PHRASES_SELECTOR_CHANGE_COLUMNS_VISIBILITY;
    wizardId: PhrasesSelectorWizardId;
    value: PhrasesSelectorColumnsVisibilityData;
}
export function changeColumnsPhrasesWizardVisibility(
    wizardId: PhrasesSelectorWizardId,
    value: PhrasesSelectorColumnsVisibilityData
): ChangePhrasesWizardColumnsVisibility {
    return {
        type: PHRASES_SELECTOR_CHANGE_COLUMNS_VISIBILITY,
        wizardId,
        value
    };
}

export const PHRASES_SELECTOR_CHANGE_PRICE_CONTEXT = 'PHRASES_SELECTOR_CHANGE_PRICE_CONTEXT';
export type PHRASES_SELECTOR_CHANGE_PRICE_CONTEXT = typeof PHRASES_SELECTOR_CHANGE_PRICE_CONTEXT;
export interface ChangePriceContextPhrasesWizardAction {
    type: PHRASES_SELECTOR_CHANGE_PRICE_CONTEXT;
    wizardId: PhrasesSelectorWizardId;
    value: number;
}
export function changePriceContextPhrasesWizard(
    wizardId: PhrasesSelectorWizardId,
    value: number
): ChangePriceContextPhrasesWizardAction {
    return {
        type: PHRASES_SELECTOR_CHANGE_PRICE_CONTEXT,
        wizardId,
        value
    };
}

export const PHRASES_SELECTOR_CHANGE_INPUT = 'PHRASES_SELECTOR_CHANGE_INPUT';
export type PHRASES_SELECTOR_CHANGE_INPUT = typeof PHRASES_SELECTOR_CHANGE_INPUT;

export interface PhrasesSelectorChangeInput {
    type: PHRASES_SELECTOR_CHANGE_INPUT;
    wizardId: PhrasesSelectorWizardId;
    value: string;
    displayIn: PhrasesSelectorInputColumns;
}

export function phrasesSelectorChangeInput(
    wizardId: PhrasesSelectorWizardId,
    value: string,
    displayIn: PhrasesSelectorInputColumns
): PhrasesSelectorChangeInput {
    return {
        type: PHRASES_SELECTOR_CHANGE_INPUT,
        wizardId,
        value,
        displayIn
    };
}

export const PHRASES_SELECTOR_SEND_MINUS_PHRASE_DATA = 'PHRASES_SELECTOR_SEND_MINUS_PHRASE_DATA';
export type PHRASES_SELECTOR_SEND_MINUS_PHRASE_DATA = typeof PHRASES_SELECTOR_SEND_MINUS_PHRASE_DATA;

export interface PhrasesSelectorSendMinusPhraseData {
    type: PHRASES_SELECTOR_SEND_MINUS_PHRASE_DATA;
    wizardId: PhrasesSelectorWizardId;
    items: PhrasesSelectorListItem[];
}

export function phrasesSelectorSendMinusPhraseData(
    wizardId: PhrasesSelectorWizardId,
    items: PhrasesSelectorListItem[]
): PhrasesSelectorSendMinusPhraseData {
    return {
        type: PHRASES_SELECTOR_SEND_MINUS_PHRASE_DATA,
        wizardId,
        items
    };
}
export const UPDATE_PHRASES_WIZARD_ERROR = 'UPDATE_PHRASES_WIZARD_ERROR';
export type UPDATE_PHRASES_WIZARD_ERROR = typeof UPDATE_PHRASES_WIZARD_ERROR;

export interface UpdatePhrasesWizardError {
    type: UPDATE_PHRASES_WIZARD_ERROR;
    wizardId: PhrasesSelectorWizardId;
    error: string;
    displayIn: PhrasesSelectorInputColumns;
}

export function updatePhrasesWizardError(
    wizardId: PhrasesSelectorWizardId,
    error: string,
    displayIn: PhrasesSelectorInputColumns
): UpdatePhrasesWizardError {
    return {
        type: UPDATE_PHRASES_WIZARD_ERROR,
        wizardId,
        error,
        displayIn
    };
}

export type PhrasesSelectorWizardAction =
    | UpdatePhrasesSelectorWizard
    | AddPhrasesStartInputItems
    | SelectionChange
    | SubmitSelectionWizard
    | DeleteStartPhrases
    | AddPhrasesToChosenList
    | RemovePhrasesFromChosenList
    | RemovePhrasesToMinusWordsList
    | AddPhrasesToMinusWordsList
    | OpenPhrasesSelectorWizard
    | ClosePhrasesSelectorWizard
    | ChangePhrasesWizardColumnsVisibility
    | AddSearchedAlsoPhrasesToStartPhrases
    | ShowPhrasesSelectorWizard
    | ChangePriceContextPhrasesWizardAction
    | FetchPhrasesForPhrasesSelectorWizardAction
    | PhrasesSelectorAction
    | PhrasesSelectorChangeInput
    | PhrasesSelectorSendMinusPhraseData
    | UpdatePhrasesWizardError;
